var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "23.997px",
    height: "24px",
    viewBox: "0 0 23.997 24",
    style: {
      enableBackground: "new 0 0 23.997 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.434,0.61H7.781c-0.459,0-0.831,0.372-0.831,0.831v3.554h1.662V2.272h12.991v12.994h-2.438v1.662h3.27 c0.459,0,0.831-0.372,0.831-0.831V1.441C23.265,0.982,22.893,0.61,22.434,0.61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.219,7.072H1.563c-0.459,0-0.831,0.372-0.831,0.831v14.656c0,0.459,0.372,0.831,0.831,0.831h14.656 c0.459,0,0.831-0.372,0.831-0.831V7.903C17.05,7.444,16.678,7.072,16.219,7.072z M15.388,21.728H2.394V8.734h12.994V21.728z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.05e2cdb6deeb08727ccf22d36d33515e.svg";
export { ForwardRef as ReactComponent };